// extracted by mini-css-extract-plugin
export default {"loading_container":"styles_loading_container__2PmKT","loading_spinne":"styles_loading_spinne__cBFmK","spin":"styles_spin__QDriL"};